/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { findGifUrl } from 'mewe/utils/gif-utils';
import PostUtils from 'mewe/utils/post-utils';
import dispatcher from 'mewe/dispatcher';

export default class MwSmartSearchPost extends Component {
  @service router;
  @service account;
  @service dynamicDialogs;

  constructor() {
    super(...arguments);
  }

  @action
  clickHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    let s = PostUtils.getPostScopeAndId(this.args.post);
    let postScope = s.scope;
    let postScopeId = s.scopeId;

    let opt = {
      scope: postScope,
      scopeId: postScopeId,
      postItemId: this.args.post.postItemId,
      threadId: this.args.post.threadId, // used in case of PP results in search
      fetchingPostForDialog: true,
      doWithPost: (thePost) => {
        this.dynamicDialogs.openDialog('single-post-dialog', {
          post: thePost,
          theme: postScope,
          scope: postScope,
        });
      },
    };

    if (this.args.post.page) opt.pageId = this.args.post.page.id;
    if (this.args.post.groupId) opt.groupId = this.args.post.groupId;

    dispatcher.dispatch('feed', 'fetchPostFromMemoryOrServer', opt);

    // !! don't close smart search, just show SPV over it so that user
    // can close post without loosing context in search
  }

  get groupOrEventAvatar() {
    if (this.args.post.isEventPost) {
      return this.args.post.event2?.avatarLink;
    } else if (this.args.post.isGroupPost) {
      return this.args.post.group?.avatarLink;
    }
  }

  get groupOrEventName() {
    if (this.args.post.isEventPost) {
      return this.args.post.event2?.name;
    } else if (this.args.post.isGroupPost) {
      return this.args.post.group?.name;
    }
  }

  get showPostText() {
    return this.args.post.textDisplay || this.args.post.album;
  }

  @computed('post.textServer')
  get isGifLinkWithGifInText() {
    return (
      !!findGifUrl(this.args.post.link?._links?.url?.href) &&
      this.args.post.textServer.indexOf(this.args.post.link?._links?.url?.href) !== -1
    );
  }

  @computed('post.album', 'args.inMediaDialog', 'args.threadId')
  get showPostAlbumName() {
    return this.args.post.album && !this.args.inMediaDialog && !this.args.threadId;
  }

}
